import { Box, Button, Flex, Text } from '@chakra-ui/react';
import { SelloutCard } from '../card';
import Export from '../../export';
import { useMainState } from '@pages/AuditTrailSellOut/state/state';
import { useConfirmModal } from '@store/useConfirmModal';
import { ConfirmationState2 } from '@assets/images';
import usePostCancelSellout from '@domain/auditTrail/usePostCancelSellout';
import { ConditionalComponent } from '@components/functionComponent';

export default function SuccessSummary() {
    const { selectedAuditTrail } = useMainState();
    const { set } = useConfirmModal();
    const {mutate: onPostCancel} = usePostCancelSellout(selectedAuditTrail?.id);

    const brands = Object.entries(selectedAuditTrail?.qty ?? {})
        .filter(([key]) => key !== 'total')
        .map(([name, value]) => ({
            name: name,
            skuCount: value.sku,
            qtyCount: value.qty,
        }));

    const summaryItems = [
        {
            title: 'Brands',
            value: brands.length,
        },
        {
            title: 'SKUs',
            value: selectedAuditTrail?.qty?.total?.sku_total ?? '-',
        },
        {
            title: 'Qty',
            value: selectedAuditTrail?.qty?.total?.qty_total ?? '-',
        },
    ];

    const handleConfirmCancel = () => {
        set({
            isOpen: true,
            title: 'Konfirmasi Pembatalan',
            desc: 'Apakah Anda yakin ingin membatalkan sellout ini?',
            btnLabelYes: 'Batalkan Sellout',
            btnLabelNo: 'Tutup',
            isShowBtnNo: true,
            ConfirmationStateImage: () => <ConfirmationState2 />,
            onSubmit: onPostCancel,
        });
    };

    return (
        <Box>
            <Box p={'16px'} bg={'semantic.200'} borderRadius={'8px'} mt={'24px'}>
                <Flex alignItems={'center'} gap={'8px'} justifyContent={'space-between'} mb={'16px'}>
                    <Text fontWeight={'bold'}>Summary</Text>

                    <Flex alignItems={'center'} gap={'12px'}>
                        {summaryItems.map((item) => (
                            <SelloutCard key={item.title} {...item} />
                        ))}
                    </Flex>
                </Flex>

                {brands.map((brand, index) => (
                    <Flex
                        key={index}
                        alignItems={'center'}
                        justifyContent={'space-between'}
                        gap={'12px'}
                        mt={index > 0 ? '8px' : '0'}
                        bg={'white'}
                        p={'8px'}
                        border={'1px solid'}
                        borderRadius={'4px'}
                        borderColor={'neutral.200'}
                    >
                        <Text fontWeight={'bold'} fontSize={'sm'}>
                            {brand.name}
                        </Text>
                        <Flex gap={'4px'}>
                            <Text fontSize={'xs'}>
                                {brand.skuCount} SKU, {brand.qtyCount} QTY
                            </Text>
                        </Flex>
                    </Flex>
                ))}
            </Box>

            <Flex
                justifyContent={selectedAuditTrail?.meta_data?.is_send_cancel ? 'space-between' : 'center'}
                mt="24px"
                gap={'16px'}
            >
                <ConditionalComponent statement={selectedAuditTrail?.meta_data?.is_send_cancel}>
                    <Button variant={'outline'} colorScheme="danger" onClick={handleConfirmCancel}>
                        Batalkan Sellout
                    </Button>
                </ConditionalComponent>

                <Export />
            </Flex>
        </Box>
    );
}
